import { useEffect, useRef, useState } from "react";
import { Autocomplete, Box, Button, FormControl, Grid, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import React from "react";
import { useNavigate } from "react-router-dom";
import getColumnsSolicitudPF from "../../../layout/Columns/ColumnsSolicitudPF";
import BreadcrumbBar from "../../../layout/BreadcrumbBar";
import { AttachFile, Close } from "@mui/icons-material";
import Swal from "sweetalert2";
import { guardarDocumentosAcuerdosAF } from "../../../services/PpafeservicesAF";
import axios from "axios";

interface TipoPublicacion {
    id: string;
    nombre: string;
    estatus: string;
    fechaAlta: string; // Puede ser Date si prefieres manejarlo como objeto Date
    fechaBaja: string | null;
    creadoPorId: string | null;
}

const SolicitudAcuerdosAF = () => {
    const [fecha, setFecha] = useState<dayjs.Dayjs | null>(dayjs());
    const [titulo, setTitulo] = useState<string>("");
    const [documento, setDocumento] = useState<string>("");
    const navigate = useNavigate();
    const TITULO = "Solicitud de Alta Aportaciones Federales Acuerdos";
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);
    const [open, setOpen] = useState(false);
    const [tituloEditado, setTituloEditado] = useState<boolean>(false); // Nuevo estado
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [tipoPublicacion, setTipoPublicacion] = useState<string | undefined>(undefined);
    const [catalogoTiposPublicacion, setCatalogoTiposPublicacion] = useState<TipoPublicacion[]>([]);
    const handleIconClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();  // Activa el input de archivos
        }
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            const fileName = file.name.toLowerCase();
            const isPdf = fileName.endsWith(".pdf");
            // Validar si el archivo es un PDF
            if (!isPdf) {
                Swal.fire({
                    title: "Formato no permitido",
                    text: "Solo puedes subir archivos en formato PDF.",
                    icon: "error",
                    confirmButtonColor: "#15212f",
                });
                return; // Detener la ejecución si el archivo no es PDF
            }
            setDocumento(file.name);
            setSelectedFile(file); // Guardamos el archivo File
            setTituloEditado(false);
            setTitulo(generarTitulo(file.name, fecha));

            if (file.type === "application/pdf") {
                const fileURL = URL.createObjectURL(file);
                setPdfUrl(fileURL);
                setOpen(true);
            }
        }
    };





    const generarTitulo = (nombreArchivo: string, fecha: Dayjs | null) => {
        if (!nombreArchivo || !fecha) return "";

        const año = fecha.year();
        const nombreSinExtension = nombreArchivo.split('.').slice(0, -1).join('.');

        return `${nombreSinExtension} - ${año}`;
    };

    const handleFechaChange = (newValue: Dayjs | null) => {
        if (!newValue) return;

        setFecha(newValue);

        // Extraemos el año actual del título si tiene formato "nombre - año"
        const match = titulo.match(/(.*) - (\d{4})$/);

        if (match) {
            const nuevoTitulo = `${match[1]} - ${newValue.year()}`;
            setTitulo(nuevoTitulo);
        } else if (!tituloEditado && documento) {
            // Si el usuario no ha editado manualmente, actualizar el título normal
            setTitulo(generarTitulo(documento, newValue));
        }
    };


    const handleTituloChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTitulo(e.target.value);
        setTituloEditado(true); // Marca el título como editado manualmente
    };


    const handleRemoveFile = () => {
        setDocumento("");
        setTitulo("");
        setSelectedFile(null); // Limpiamos el archivo
        setPdfUrl(null);
        setFecha(dayjs());
    };
    const handleGuardar = () => {
        const tipo = "aportaciones";
        const origen = "federales";
        const tipo_publicacion_id = tipoPublicacion || "";
        const fechaFormateada = fecha ? fecha.format("YYYY-MM-DD") : null;

        guardarDocumentosAcuerdosAF(
            titulo,
            fechaFormateada,
            tipo,
            origen,
            selectedFile,
            tipo_publicacion_id,
            setLoading,
            setError,
            navigate,
        ).then((response) => {
            if (response) {
                // Opcional: navegar a otra página o limpiar el formulario
                // navigate("/admin/participaciones/federales/acuerdos");
            }
        });
    };

    const obtenerCatalogoTipoPublicacion = async (): Promise<void> => {
        setLoading(true);
        setError(null);
        try {
            const url = `${process.env.REACT_APP_APPLICATION_ENDPOINT}/public/consulta/tipopublicacion`; // Corrección en la concatenación de la URL
            const { status, data: result } = await axios.get(url, {
                headers: {
                    Authorization: localStorage.getItem("jwtToken") || "",
                    "Content-Type": "application/json",
                },
            });

            if (status !== 200) {
                throw new Error(`Error HTTP: ${status}`);
            }

            const data: TipoPublicacion[] = result.data || []; // Asegura que `data` sea un array
            if (data.length === 0) {
                console.warn('El catálogo está vacío');
            } else {

                setCatalogoTiposPublicacion(data); // Actualiza el estado con los datos
            }

        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : "Error desconocido";
            console.error("Error al obtener el catálogo:", errorMessage);
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };



    // Efecto para cargar los datos al montar el componente
    useEffect(() => {
        obtenerCatalogoTipoPublicacion();
    }, []);
    return (
        <>
            <Grid container sx={{}}>
                <Grid item mb={2} width={"100%"}>
                    <BreadcrumbBar
                        links={[
                            { texto: "Inicio", link: "/admin" },
                            { texto: "Acuerdos", link: "/admin/aportaciones/federales/acuerdos" },
                        ]}
                        Titulo={TITULO}
                    />
                </Grid>
                <Grid item width={"100%"} sx={{ marginBottom: "1rem" }}>

                    <Typography
                        variant="h5"
                        component="div"
                        sx={{
                            flexGrow: 1,
                            fontWeight: "bold",
                            display: "flex",
                            justifyContent: "left",

                        }}

                    >
                        {TITULO}
                    </Typography>

                </Grid>

                <Grid item mb={2} width={"100%"}>
                    <p>Nota: Por favor, asegúrese de llenar todos los campos obligatorios antes de guardar la información.</p>
                    <TextField
                        label="Título"
                        fullWidth
                        value={titulo}
                        onChange={handleTituloChange}
                        sx={{ marginTop: "1rem" }}
                    />
                </Grid>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={4}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                                label="Fecha"
                                value={fecha}
                                onChange={handleFechaChange}
                                renderInput={(params) => (
                                    <TextField {...params} fullWidth sx={{ height: "3.7rem" }} />
                                )}
                            />
                        </LocalizationProvider>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth>
                            <Autocomplete
                                id="tipo-publicacion"
                                options={catalogoTiposPublicacion}
                                getOptionLabel={(option) => option.nombre}
                                value={catalogoTiposPublicacion.find((p) => p.id === tipoPublicacion) || null}
                                onChange={(_, newValue) => setTipoPublicacion(newValue?.id)}
                                renderInput={(params) => (
                                    <TextField {...params} label="Tipo de Publicación" placeholder="Selecciona un tipo" />
                                )}
                                disabled={loading}
                            />
                        </FormControl>
                    </Grid>


                    <Grid item xs={12} md={4}>
                        <TextField
                            label="Adjuntar Archivo"
                            fullWidth
                            value={documento}
                            sx={{ height: "3.7rem" }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleIconClick}>
                                            <AttachFile />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            disabled // Deshabilitamos la edición manual
                        />
                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: "none" }} // Ocultamos el input de archivos
                            onChange={handleFileChange}
                        />
                    </Grid>
                </Grid>
                {/* Previsualización del PDF dentro de un Grid */}
                {pdfUrl && (
                    <Grid item mt={2} width={"100%"}>
                        {/* Contenedor para alinear Typography e IconButton */}
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Typography variant="subtitle1">Vista Previa del Documento</Typography>
                            <IconButton
                                sx={{
                                    backgroundColor: 'white',
                                    boxShadow: 2,
                                }}
                                onClick={handleRemoveFile}
                            >
                                <Close />
                            </IconButton>
                        </Box>

                        {/* Contenedor del documento */}
                        <Box
                            sx={{
                                position: 'relative',
                                width: '100%',
                                height: '400px',
                                border: '1px solid #ccc',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <iframe
                                src={pdfUrl}
                                width="100%"
                                height="100%"
                                style={{ border: "none" }}
                            ></iframe>
                        </Box>
                    </Grid>
                )}


                <Grid
                    container
                    justifyContent={{ xs: "center", md: "flex-end" }}
                    spacing={2}
                    direction={{ xs: "column", sm: "row" }}
                    sx={{ mt: 2 }}
                >
                    <Grid item>
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={() => {
                                navigate("/admin/aportaciones/federales/acuerdos");
                            }}
                            sx={{
                                backgroundColor: "#C1A25C",
                                textTransform: "capitalize",
                                width: { xs: "100%", sm: "7rem" },
                            }}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={handleGuardar}
                            color="primary"
                            sx={{
                                textTransform: "capitalize",
                                width: { xs: "100%", sm: "7rem" },
                            }}
                        >
                            Guardar
                        </Button>
                    </Grid>
                </Grid>


            </Grid >
        </>
    );
};

export default SolicitudAcuerdosAF;
